import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

import { ImageProvider } from './context/ImageContext';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import MainCreate from './components/MainCreate/MainCreate';
import ImageEditor from './components/ImageEditor/ImageEditor';
import UserProfile from './components/UserProfile/UserProfile';
import MainEdit from './components/MainEdit/MainEdit';
import Main from './components/Sidebar/Main';
import Canvas from './components/Canvas/Canvas';
import PaymentSuccessful from './components/Stripe/PaymentSuccessful';
import PaymentFailed from './components/Stripe/PaymentFailed';
import MainLandingPage, { use_cases } from './components/landingPage/MainLandingPage';
import MobileView from './components/MobileView/MobileView';
import UseCasesPage from './components/landingPage/UseCasesPage';
import PricingPage from './components/landingPage/PricingPage';
import TermsAndConditionsPage from './components/landingPage/TermsAndConditionsPage';

import { USER_NAME } from './constant';
import { generatePresignedUrl, listFileNamesFromS3, listFoldersFromS3, readFileFromS3 } from './config/aws';
import { fetchAllEditHistory, fetchAllCreateHistory } from './utils/utilities';
import { getUserCredits } from './dbApiFunctions';


import Layout from './components/loginRegister/Layout'
import { authenticateUser } from './dbApiFunctions';


function App() {
  const [selectedEditGroup, setSelectedEditGroup] = useState([{ src: "", alt: "Default edit image" }]);
  const [creditsAvailable, setCreditsAvailable] = useState(0);
  const [editUploadedImages, setEditUploadedImages] = useState([{ src: "https://res.cloudinary.com/dxfs2irxa/image/upload/v1745483370/editDefault_1_bt7bcp.jpg", alt: "Default edit image" }]);
  const [brushSize, setBrushSize] = useState(20);
  const [eraserSize, setEraserSize] = useState(20);
  const [activeButton, setActiveButton] = useState('pen');
  const [allCreateHistory, setAllCreateHistory] = useState([]);
  const [allEditHistory, setAllEditHistory] = useState([]);
  const [allBGHCreateHistory, setAllBGHCreateHistory] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [createPageNumber, setCreatePageNumber] = useState(0);
  const [editPageNumber, setEditPageNumber] = useState(0);
  const [bghPageNumber, setBghPageNumber] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState({ "src": "https://img.icons8.com/?size=100&id=106359&format=png&color=000000", "name": "Select a Product Image", "refNum": null });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1020);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1020);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Load session data on component mount
  useEffect(() => {
    const EMAIL = sessionStorage.getItem("email");
    const PASSWORD = sessionStorage.getItem("password");

    const auth = getAuth();
    signInWithEmailAndPassword(auth, EMAIL, PASSWORD)
      .then((userCredential) => {
        setIsLoggedIn(true);
      })
      .catch((error) => {
        console.error("Authentication error:", error);
      });
  }, []);


  useEffect(() => {
    const EMAIL = sessionStorage.getItem("email");
    getUserCredits(EMAIL).then(response => {
      if (response.status) {
        setCreditsAvailable(response.credits);
      }
    }).catch(error => console.error(error));
  }, []);

  useEffect(() => {
    fetchAllCreateHistory(allCreateHistory, setAllCreateHistory, createPageNumber, 'all_createPage');
  }, [createPageNumber]);

  useEffect(() => {
    fetchAllEditHistory(allEditHistory, setAllEditHistory, editPageNumber);
  }, [editPageNumber]);

  useEffect(() => {
    fetchAllCreateHistory(allBGHCreateHistory, setAllBGHCreateHistory, bghPageNumber, 'all_bghPage');
  }, [bghPageNumber]);

  // if (isMobile) {
  //   return <MobileView />;
  // }

  return (
    <Router>
      {
        isLoggedIn
          ? 
            isMobile ? ( <MobileView /> ) : (
            <ImageProvider>
              <div className="bg-gray-50 min-h-screen flex flex-col">
                <div className="w-full">
                  <Header creditsAvailable={creditsAvailable} />
                </div>
                <Routes>
                  <Route path="/webapp" element={
                    <div className="flex flex-1">
                      <Sidebar
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        brushSize={brushSize}
                        setBrushSize={setBrushSize}
                        eraserSize={eraserSize}
                        setEraserSize={setEraserSize}
                        activeButton={activeButton}
                        setActiveButton={setActiveButton}
                        selectedProduct={selectedProduct}
                        setSelectedProduct={setSelectedProduct}
                        fetchAllCreateHistory={fetchAllCreateHistory}
                        fetchAllEditHistory={fetchAllEditHistory}
                        allCreateHistory={allCreateHistory}
                        setAllCreateHistory={setAllCreateHistory}
                        allEditHistory={allEditHistory}
                        setAllEditHistory={setAllEditHistory}
                        allBGHCreateHistory={allBGHCreateHistory}
                        setAllBGHCreateHistory={setAllBGHCreateHistory}
                        setCreditsAvailable={setCreditsAvailable}
                        setSelectedEditGroup={setSelectedEditGroup}
                        setCreatePageNumber={setCreatePageNumber}
                        setBghPageNumber={setBghPageNumber}
                        setEditPageNumber={setEditPageNumber}
                      />
                      <Main
                        editUploadedImages={editUploadedImages}
                        setEditUploadedImages={setEditUploadedImages}
                        brushSize={brushSize}
                        eraserSize={eraserSize}
                        activeButton={activeButton}
                        allCreateHistory={allCreateHistory}
                        allEditHistory={allEditHistory}
                        allBGHCreateHistory={allBGHCreateHistory}
                        setAllEditHistory={setAllEditHistory}
                        createPageNumber={createPageNumber}
                        bghPageNumber={bghPageNumber}
                        editPageNumber={editPageNumber}
                        setCreatePageNumber={setCreatePageNumber}
                        setBghPageNumber={setBghPageNumber}
                        setEditPageNumber={setEditPageNumber}
                        creditsAvailable={creditsAvailable}
                        setCreditsAvailable={setCreditsAvailable}
                        selectedEditGroup={selectedEditGroup}
                        setSelectedEditGroup={setSelectedEditGroup}
                      />

                    </div>
                  } />

                  <Route path="/profile" element={<UserProfile />} />
                  <Route path="/paymentSuccess" element={<PaymentSuccessful />} />
                  <Route path="/paymentFailed" element={<PaymentFailed />} />
                  <Route path="/use-cases" element={<UseCasesPage use_cases={use_cases} />} />
                  <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
                </Routes>
              </div>
            </ImageProvider>
          ) : (
            <Routes>
              <Route path="/webapp" element={<Layout setIsLoggedIn={setIsLoggedIn} />} />
              <Route path="/" element={<MainLandingPage />} />
              <Route path="/use-cases" element={<UseCasesPage use_cases={use_cases} />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/paymentSuccess" element={<PaymentSuccessful />} />
              <Route path="/paymentFailed" element={<PaymentFailed />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
            </Routes>
          )
      }
    </Router>
  );
}

export default App;

